import LabelImportantOutlinedIcon from "@mui/icons-material/LabelImportantOutlined";
import { Button } from "@mui/material";
import type { GridRowSelectionModel } from "@mui/x-data-grid-premium";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedRowIdsFromModel } from "@entrilia/shared/components/grid/gridHelper";
import { markAsImportantUpdatingSelector, messagesSelector } from "../../../../../store/state/messages/selectors";
import { markAsImportant } from "../../../../../store/state/messages/thunks";
import { impersonationSelector } from "../../../../../store/state/user/selectors";
import type { AppDispatch } from "../../../../../store/store";

interface Props {
  compact?: boolean;
  selection: GridRowSelectionModel;
}

export const MarkAsNotImportantAction = (props: Props) => {
  const { compact, selection } = props;

  const dispatch: AppDispatch = useDispatch();

  const messages = useSelector(messagesSelector);
  const isImpersonation = useSelector(impersonationSelector);
  const markAsImportantUpdating = useSelector(markAsImportantUpdatingSelector);

  const anyImportantMessagesInSelected = useMemo(() => {
    return !!messages.find((msg) => selection.ids.has(msg.id) && msg.isImportant);
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [messages, selection, markAsImportantUpdating]);

  const changeSelectedMessagesImportance = useCallback(
    (isImportant: boolean) => {
      dispatch(markAsImportant(getSelectedRowIdsFromModel(selection), isImportant));
    },
    [dispatch, selection]
  );

  const allowMarkAsNotImportantAction = useMemo(() => {
    return selection && selection.ids.size > 0 && anyImportantMessagesInSelected;
  }, [selection, anyImportantMessagesInSelected]);

  return (
    <>
      {allowMarkAsNotImportantAction && (
        <Button
          disabled={isImpersonation}
          startIcon={<LabelImportantOutlinedIcon />}
          loadingPosition="start"
          loading={markAsImportantUpdating}
          onClick={() => changeSelectedMessagesImportance(false)}
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            flexDirection: compact === true ? "column" : "inherit",
          })}
        >
          Not Important
        </Button>
      )}
    </>
  );
};

export default MarkAsNotImportantAction;
